/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CloudPairingClientSecretVlrOrgSecretSpec { 
    ref_id: string;
    client_secret: string;
}

